module.exports = "/_next/static/images/b0b775b7b57594a517565913fd7efe08-medium-techcrunch.png";